var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-base-layout',[_c('template',{slot:"user-profile"},[_c('user-orders')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }